import React from 'react';
import Layout from '../components/Layout';
import get from 'lodash/get';
import { graphql } from 'gatsby';
import SEO from "../components/SEO"

class Confirm extends React.Component {
  render() {
    const siteTitle = get(this.props, 'data.site.siteMetadata.title');
    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title="Successful Contact"
          description="Thank you for contacting me. I'll get in touch as soon as possible."
          slug='/success/'
        />
        <h1>Thanks!</h1>
        <p>
          Thank you for contacting me. I'll get in touch as soon as possible.
        </p>
      </Layout>
    );
  }
}

export const pageQuery = graphql`
  query ConfirmSiteData {
    site {
      siteMetadata {
        title
      }
    }
  }
`;

export default Confirm;
